/*
 * Copyright © 2020-2025 XCamera. All Rights Reserved.
 * @Description:
 * @LastEditors: yingongjing
 * @LastEditTime: 2025-07-24 17:54:27
 */
import { useState, useEffect, useCallback } from 'react'
import { fetchAIRecognitionExamplePhotos } from '../../../actions/aiRecognition'
import { useAppDispatch } from '../../../app/hooks'

// Hook状态接口
interface UseExamplePhotosState {
  photos: string[]
  fetchPhotos: (count?: number) => Promise<void>
  refreshPhotos: () => Promise<void>
}

export const useExamplePhotos = (
  initialCount: number = 7
): UseExamplePhotosState => {
  const dispatch = useAppDispatch()
  const [photos, setPhotos] = useState<string[]>([])

  /**
   * 获取示例照片数据
   * @param count 要获取的照片数量
   */
  const fetchPhotos = useCallback(
    async (count: number = initialCount): Promise<void> => {
      try {
        const response = await dispatch(
          fetchAIRecognitionExamplePhotos({
            count
          })
        )

        // 处理API返回的数据
        if (response && response && Array.isArray(response.list)) {
          const photoUrls = response.list
          setPhotos(photoUrls)
        }
      } catch (err) {
        console.error('获取示例照片失败:', err)
      }
    },
    [dispatch, initialCount]
  )

  /**
   * 刷新照片数据
   */
  const refreshPhotos = useCallback(async (): Promise<void> => {
    await fetchPhotos(initialCount)
  }, [fetchPhotos, initialCount])

  // 组件挂载时自动获取照片
  useEffect(() => {
    fetchPhotos(initialCount)
  }, []) // 只在组件挂载时执行一次

  return {
    photos,
    fetchPhotos,
    refreshPhotos
  }
}

export default useExamplePhotos
